import { Controller } from '@hotwired/stimulus'

import { withStatusPolling } from '../../src/mixins/with_status_polling'

/**
 * Retrieves the EFB data (Electronic Flight Bag aircraft positions)
 *
 * Broadcasts it to the page (via an EfbUpdate event)
 */
export default class extends Controller {
  static values = {
    refreshRate: {
      type: Number,
      default: 5_000
    },
    url: String
  }

  connect () {
    withStatusPolling(this, this.urlValue, this.refreshRateValue, this.dispatchEfbUpdate.bind(this))
  }

  dispatchEfbUpdate (res) {
    if (res.aircrafts) {
      this.dispatch('efbUpdate', { detail: res.aircrafts })
    }
  }
}
